import { IOrganization } from '@/pages/Organizations/organizations.types'
import { IUser } from '@/pages/Users/users.types'
import http, { handleHttpError, handleHttpResponse } from '@/services/http'
import type { AxiosError } from 'axios'
import { HTTPResponse } from '@/services/http/http.types'

const getErrorMessage = async (data: unknown): Promise<string | null> => {
  if (!data) return null

  if (typeof Blob !== 'undefined' && data instanceof Blob) {
    const text = await data.text()
    try {
      const parsed = JSON.parse(text) as { message?: string }
      if (typeof parsed?.message === 'string') return parsed.message
    } catch {
      if (text) return text
    }
  }

  if (typeof data === 'string') {
    try {
      const parsed = JSON.parse(data) as { message?: string }
      if (typeof parsed?.message === 'string') return parsed.message
    } catch {
      return data
    }
  }

  if (typeof data === 'object' && 'message' in data) {
    const message = (data as { message?: unknown }).message
    if (typeof message === 'string') return message
  }

  return null
}

const getXlsxMaintenanceReport = async (
  id: IOrganization['id'],
  params: {
    date_gte: string
    date_lte: string
    userId?: IUser['id']
  }
): Promise<HTTPResponse<Blob>> => {
  return http
    .get(`/docs/v1/maintenanceReport/${id}/generate`, {
      responseType: 'blob',
      params,
      paramsSerializer: (p) =>
        Object.entries(p)
          .map(([k, v]) => `${k}=${v}`)
          .join('&'),
    })
    .then(handleHttpResponse)
    .catch(async (error: AxiosError) => {
      const fallback = handleHttpError(error)
      const customMessage = await getErrorMessage(error?.response?.data)

      if (customMessage) {
        return { ...fallback, message: customMessage }
      }

      return fallback
    })
}

const myOrganizationApi = {
  getXlsxMaintenanceReport,
}

export default myOrganizationApi
